import './sass/style.scss';
import './js/app.js';

import * as components0 from '../views/components/delivery__popup/index.js'; import * as components1 from '../views/components/menu/horizontal/horizontal.js'; import * as components2 from '../views/components/newsletter__popup/index.js'; import * as components3 from '../views/components/newsletter/index.js'; import * as components4 from '../views/components/ProductsSlider/index.js'; import * as components5 from '../views/components/searchform/index.js'; import * as components6 from '../views/components/slider/basic/index.js'; let components = [components0, components1, components2, components3, components4, components5, components6];
;
import * as woocommerce0 from '../views/woocommerce/archive-product/archive-product.js'; import * as woocommerce1 from '../views/woocommerce/components/AddedToCartPopup/added-to-cart-popup.js'; import * as woocommerce2 from '../views/woocommerce/components/ProductGallery/product-gallery.js'; import * as woocommerce3 from '../views/woocommerce/components/SidebarCart/sidebar-cart.js'; let woocommerce = [woocommerce0, woocommerce1, woocommerce2, woocommerce3];
import { filter } from 'core-js/es/array';
// import { filter } from 'core-js/core/array';

jQuery(function ($) {
    // clones custom options for each product attribute
    var clone = $('.single-product div.product  table.variations .custom_options').clone(
        true,
        true,
    );

    // adds a "data-parent-id" attribute to each custom option
    $('.single-product div.product  table.variations .custom_option').each(function () {
        $(this).attr('data-parent-id', $(this).parent().attr('id'));
    });

    // when a user clicks on a custom option it adds the "selected" attribute to the respective select option
    $(document).on('click', '.custom_option', function () {
        var parentID = $(this).data('parent-id');
        if ($(this).hasClass('on')) {
            $(this).removeClass('on');
            $('.single-product div.product  table.variations select#' + parentID)
                .val('')
                .trigger('change');
        } else {
            $('.custom_option[data-parent-id=' + parentID + ']').removeClass('on');
            $(this).addClass('on');
            $('.single-product div.product  table.variations select#' + parentID)
                .val($(this).data('value'))
                .trigger('change');
        }
    });

    // if a select option is already selected, it adds the "on" attribute to the respective custom option
    $('.single-product div.product  table.variations select').each(function () {
        if ($(this).find('option:selected').val()) {
            var id = $(this).attr('id');
            $('.custom_option[data-parent-id=' + id + ']').removeClass('on');
            var value = $(this).find('option:selected').val();
            $('.custom_option[data-parent-id=' + id + '][data-value=' + value + ']').addClass('on');
        }
    });

    // when the select options change based on the ones selected, it shows or hides the respective custom options
    $('body').on('check_variations', function () {
        $('div.custom_option').removeClass('is-visible');
        $('.single-product div.product  table.variations select').each(function () {
            var attrID = $(this).attr('id');
            $(this)
                .find('option')
                .each(function () {
                    if ($(this).val() == '') {
                        return;
                    }
                    $(
                        'div[data-parent-id="' + attrID + '"][data-value="' + $(this).val() + '"]',
                    ).addClass('is-visible');
                });
        });
    });

    // reinsert the clone of the custom options of the attributes in the page
    $(clone).insertBefore('.single-product div.product  table.variations .reset_variations').hide();
});

const open__sizes__popup = document.querySelector('.open__sizes__popup');
const close__sizes__popup = document.querySelector('.close__sizes__table');
const sizes__table__popup = document.querySelector('.sizes__table__popup ');

if (open__sizes__popup && sizes__table__popup) {
    open__sizes__popup.addEventListener('click', () => {
        sizes__table__popup.classList.add('active');
    });
}

if (close__sizes__popup && sizes__table__popup) {
    close__sizes__popup.addEventListener('click', () => {
        sizes__table__popup.classList.remove('active');
    });
}

const qtyWrappers = document.querySelectorAll('.qty-wrapper');
if (qtyWrappers) {
    qtyWrappers.forEach((qtyWrapper, index) => {
        const increaseBtn = qtyWrapper.querySelector('.increase-qty');
        const decreaseBtn = qtyWrapper.querySelector('.decrease-qty');
        const input = qtyWrapper.querySelector('.qty');

        let inStock = null;
        let value = null;

        const syncQuantity = (targetValue) => {
            qtyWrappers.forEach((otherWrapper, otherIndex) => {
                if (otherIndex !== index) {
                    const otherInput = otherWrapper.querySelector('.qty');
                    otherInput.value = targetValue;
                }
            });
        };

        if (input) {
            increaseBtn.addEventListener('click', (e) => {
                e.preventDefault();
                value = input.value;
                const stockValue = qtyWrapper.getAttribute('data-stock');

                if (stockValue !== null && !isNaN(stockValue) && stockValue >= 1) {
                    inStock = parseInt(stockValue);

                    if (value < inStock) {
                        value++;
                        input.value = value;
                        syncQuantity(value);
                    }
                }
            });

            decreaseBtn.addEventListener('click', (e) => {
                e.preventDefault();
                value = input.value;

                if (value > 1) {
                    value--;
                    input.value = value;
                    syncQuantity(value);
                }
            });

            input.addEventListener('input', () => {
                value = input.value;

                if (value < 1) {
                    input.value = 1;
                    syncQuantity(1);
                } else if (inStock !== null && value > inStock) {
                    input.value = inStock;
                    syncQuantity(inStock);
                } else {
                    syncQuantity(value);
                }
            });
        }
    });
}

jQuery(document).ready(function ($) {
    // When the custom option is clicked
    $('.custom_option span').on('click', function () {
        var selectedValue = $(this).parent().data('value');

        // Set the corresponding value in the default select box
        $('.variations_form select').val(selectedValue).change();
    });

    // When the default select box value changes
    $('.variations_form select').on('change', function () {
        var selectedValue = $(this).val();

        // Set the corresponding value in the custom div
        $('.custom_option').removeClass('selected on');
        $('.custom_option[data-value="' + selectedValue + '"]').addClass('selected on');
    });
});

const updateOtherCartTotal = () => {
    const sidebarCartTotal = parseFloat(
        $('#sidebar-cart-total').find('bdi').text().replace(',', '.'),
    );
    const difference = 60 - sidebarCartTotal;
    const progressBar = $('#progressBar');
    const fillBar = $('#fillBar');

    if (sidebarCartTotal >= 60) {
        $('#other-cart-total').html('Darmowa dostawa dostępna');
        fillBar.css('background-color', '#29CC80');
        fillBar.css('width', '100%');
    } else {
        $('#other-cart-total').html(`brakuje Ci tylko ${difference.toFixed(2)} zł`);
        const fillPercentage = ((60 - difference) / 60) * 100;
        fillBar.css('background-color', '#F5AD1D');
        fillBar.animate({ width: `${fillPercentage}%` }, 60); // Dodana animacja szerokości
    }
};

const observer = new MutationObserver(updateOtherCartTotal);
const targetNode = document.getElementById('sidebar-cart-total');

observer.observe(targetNode, { childList: true, subtree: true });

$(document).ready(function () {
    updateOtherCartTotal();
});

// Pobierz wszystkie checkboxy
const checkboxes = document.querySelectorAll('.wcqcs-cross-sells input[type="checkbox"]');
// Dodaj obsługę zdarzenia click dla checkboxów
checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
        // Pobierz wartość atrybutu value klikniętego checkboxa
        const checkboxValue = this.getAttribute('value');

        // Znajdź wszystkie checkboxy o takiej samej wartości atrybutu value
        const correspondingCheckboxes = document.querySelectorAll(
            `.wcqcs-cross-sells input[type="checkbox"][value="${checkboxValue}"]`,
        );

        // Zaznacz/zdezaktywuj znalezione checkboxy
        const isChecked = this.checked;
        correspondingCheckboxes.forEach(function (correspondingCheckbox) {
            correspondingCheckbox.checked = isChecked;
        });
    });
});



const targetElement = document.querySelector('.stickyTarget');
const stickyBar = document.querySelector('.sticky__product__bar__desktop.mobile');

if (targetElement && stickyBar) {
    window.addEventListener('scroll', function () {
        var scrollPosition = window.scrollY || window.pageYOffset;

        if (scrollPosition >= targetElement.offsetTop) {
            // Dodaj klasę "active" do diva o klasie ".sticky__product__bar__desktop.mobile"
            stickyBar.classList.add('active');
        } else {
            // Usuń klasę "active" z diva o klasie ".sticky__product__bar__desktop.mobile"
            stickyBar.classList.remove('active');
        }
    });
}

// const showlogin = document.querySelector('.showlogin');

// if (showlogin) {
//     showlogin.addEventListener('click', function () {
//         const nextElement = this.nextElementSibling;
//         if (nextElement) {
//             nextElement.classList.toggle('active');
//         }
//     });
// }

const expand__menu = document.querySelectorAll('.expand__menu');
if (expand__menu) {
    expand__menu.forEach((expand) => {
        expand.addEventListener('click', () => {
            expand.classList.toggle('active');
        });
    });
}

const expand__category__desc = document.getElementById('expand__category__desc');
const category__desc = document.querySelector('.term-description');
if (!category__desc && expand__category__desc) {
    expand__category__desc.style.display = 'none';
}
if (expand__category__desc && category__desc) {
    expand__category__desc.addEventListener('click', () => {
        category__desc.classList.toggle('active');
        if (category__desc.classList.contains('active')) {
            expand__category__desc.innerHTML = 'Zwiń';
        } else {
            expand__category__desc.innerHTML = 'Rozwiń';
        }
    });
}
if (!expand__category__desc && !category__desc) {
}

let reservationTimerInterval; // Zmienna przechowująca interwał licznika
const czasRezerwacji = 600; // Czas rezerwacji w sekundach (10 minut = 600 sekund)
let czasOstatniegoDodania = parseInt(localStorage.getItem('czasOstatniegoDodania'));
if (!czasOstatniegoDodania || isNaN(czasOstatniegoDodania)) {
    czasOstatniegoDodania = Math.floor(Date.now() / 1000);
    localStorage.setItem('czasOstatniegoDodania', czasOstatniegoDodania);
}

function odswiezLicznik(czasOstatniegoDodania) {
    const czasTeraz = Math.floor(Date.now() / 1000); // Aktualny czas w sekundach
    const czasOdDodania = czasTeraz - czasOstatniegoDodania;
    const pozostalyCzas = czasRezerwacji - czasOdDodania;

    if (pozostalyCzas <= 0) {
        // Jeśli czas rezerwacji upłynął, ukryj div "reservation"
        if (document.getElementById('reservation')) {
            document.getElementById('reservation').style.display = 'none';
        }
        clearInterval(reservationTimerInterval); // Wyczyść interwał licznika
    } else {
        // Oblicz minutę i sekundy
        const minuty = Math.floor(pozostalyCzas / 60);
        const sekundy = pozostalyCzas % 60;

        // Wyświetl pozostały czas w elemencie "reservation__timer"
        if (document.getElementById('reservation__timer')) {
            document.getElementById('reservation__timer').innerText = `${minuty}:${
                sekundy < 10 ? '0' : ''
            }${sekundy} sek`;
        }
    }
}

// Funkcja rozpoczynająca liczenie czasu rezerwacji
function rozpocznijLicznik() {
    odswiezLicznik(czasOstatniegoDodania); // Wywołaj funkcję odświeżającą licznik, aby zaktualizować go od razu

    // Ustaw interwał odświeżający licznik co sekundę
    reservationTimerInterval = setInterval(function () {
        odswiezLicznik(czasOstatniegoDodania);
    }, 1000);
}

// Funkcja obsługująca zmianę wartości koszyka
function obsluzZmianeKoszyka() {
    const targetNode = document.getElementById('sidebar-cart-total');
    const observer = new MutationObserver(function () {
        // Zatrzymaj interwał licznika, aby zacząć odliczanie od zera
        clearInterval(reservationTimerInterval);

        // Zresetuj czas ostatniego dodania produktu na aktualny czas
        czasOstatniegoDodania = Math.floor(Date.now() / 1000);
        localStorage.setItem('czasOstatniegoDodania', czasOstatniegoDodania);

        // Wywołaj funkcję rozpoczynającą liczenie czasu rezerwacji
        rozpocznijLicznik();
    });

    observer.observe(targetNode, { childList: true, subtree: true });
}

// Wywołanie funkcji rozpoczynającej liczenie czasu rezerwacji i obsługi zmiany wartości koszyka
$(document).ready(function () {
    rozpocznijLicznik();
    obsluzZmianeKoszyka();
});
